import { render } from "./atas.vue?vue&type=template&id=728ddbed&scoped=true"
import script from "./atas.vue?vue&type=script&lang=js"
export * from "./atas.vue?vue&type=script&lang=js"

import "./atas.vue?vue&type=style&index=0&id=728ddbed&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728ddbed"]])

export default __exports__